import React from 'react';
import {Fade as MuiFade} from '@material-ui/core';

const Fade = React.forwardRef((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <MuiFade in ref={ref} {...props} />
));

export default Fade;
